/**
 * Extracts a human-readable message from a rejected RTK Query mutation
 * (the proxy `ApiError` envelope) for inline form display. Surfaces
 * per-field `details` and well-known `reason` codes when present, then
 * falls back to the canonical `message`, finally to `fallback`.
 */
export function extractApiError(err: unknown, fallback: string): string {
  if (err && typeof err === 'object' && 'data' in err) {
    const data = (err as { data?: unknown }).data
    if (data && typeof data === 'object') {
      const envelope = data as {
        message?: unknown
        reason?: unknown
        details?: Record<string, unknown>
      }

      if (envelope.reason === 'SECRET_ALREADY_EXISTS') {
        return 'A secret with this key already exists.'
      }
      if (envelope.reason === 'SECRET_UNAVAILABLE') {
        return 'Secret store is unavailable or not configured.'
      }

      if (envelope.details && typeof envelope.details === 'object') {
        const firstDetail = Object.values(envelope.details).find(
          (v) => typeof v === 'string' && v.length > 0
        )
        if (typeof firstDetail === 'string') return firstDetail
      }

      if (typeof envelope.message === 'string' && envelope.message.length > 0) {
        return envelope.message
      }
    }
  }
  return fallback
}
